<template>
  <div id="app">
    <div class="container text-center mt-5 mb-5"
         v-if="translatorLoading === true || appInfoLoading === true  || !userValidated">
      <loading/>
      <br>
      {{ t('Loading') }}
    </div>
    <div class="container text-center mt-5 mb-5" v-if="false === hasGeoIPAccess">
      <img src="/static/logo-black.png" class="logo" alt="logo">
      <div>{{t('This applications can only be used from Slovakia.')}}</div>
    </div>
    <template v-if="translatorLoading === false && true === hasGeoIPAccess && userValidated">
      <alert/>
      <router-view/>
    </template>
    <b-modal
      :visible="logoutModalVisible"
      ok-only
      :ok-title="t('Continue')"
      no-close-on-backdrop
      @ok="refreshToken"
      hide-header-close
      :title="t('Inactivity warning')"
    >
      <template v-if="isLoggedOut">
        <p>{{t('You have been inactive for 30 minutes.')}}</p>
        <p>{{t('For security reasons, you have been automatically logged out')}}</p>
      </template>
      <template v-if="!isLoggedOut">
        <p>{{t('You have been inactive for 30 minutes.')}}</p>
        <p>{{t('For security reasons, you will be automatically logged out in')}} {{ minutesToLogout }}:{{
          secondsToLogout }}</p>
      </template>
    </b-modal>
  </div>
</template>
<script>
    import TheMainMenu from '../admin/Layout/TheMainMenu';
    import Alert from '../core/Alert';
    import Notifications from '../components/notifications';
    import Loading from '../core/Components/loading';
    import CC from 'CookieConsent';

    export default {
        components: {
            Loading,
            Alert,
            TheMainMenu,
            Notifications,
        },
        data() {
            return {
                appVersion: {'server':null,'client':null},
                hasGeoIPAccess: true,
                appInfoLoading: true,
                resolvedCountry: '',
                timeToLogout: 2 * 60 * 60 * 1000,
                logoutModalVisible: false,
                isLoggedOut: true,
                userValidated: false,
                //userStore: this.getUserStore()
            };
        },
        created() {
            this.validateUser();
        },
        mounted() {
            //this.initCookieDisclaimer();
            this.getAppInfo()
            setTimeout(this.checkForTimeToLogout, 1000);
        },
        watch: {
            '$route'() {
                this.validateUser();
            },
            timeToLogout() {
                this.logoutModalVisible = null !== localStorage.getItem('csrf') && this.timeToLogout <= 10 * 60 * 1000
            },
        },
        computed: {
            translatorLoading() {
                return this.$store.state.translate.loading;
            },
            minutesToLogout() {
                if (this.timeToLogout <= 0) {
                    return '00';
                }

                return ('0' + Math.floor(this.timeToLogout / 1000 / 60 % 60)).substr(-2);
            },
            secondsToLogout() {
                if (this.timeToLogout <= 0) {
                    return '00';
                }

                return ('0' + Math.floor(this.timeToLogout / 1000 % 60)).substr(-2);
            },
        },
        methods: {
            initCookieDisclaimer() {
                //https://www.osano.com/cookieconsent/documentation/javascript-api/
                window.cookieconsent.initialise({
                    type: 'info',
                    // type: 'opt-in',
                    // type: 'opt-out',
                    container: document.getElementById('content'),
                    content: {
                        message: 'Táto stránka používa súbory cookies. Pre viac informácií, kliknite na naslednovný odkaz: ',
                        link: 'Informácie o využití cookies',
                        href: window.location.protocol + '//' + window.location.host + '/public/cookie-policy',
                        dismiss: 'Rozumiem',
                        allow: 'Povoliť',
                        deny: 'Odmietnuť',
                    },
                    palette: {
                        popup: {background: '#fff'},
                        button: {background: '#aa0000'},
                    },
                    revokable: true,
                    law: {
                        regionalLaw: false
                    },
                    location: true
                });
            },
            verifyPin() {
                //TODO: this should go to accountCheckPin
                let pin = CryptoJS.enc.Utf8.parse(this.getUserStore().getLoggedUser().get('securityPin'));
                this.loading = true;
                this.$store.dispatch('account/verifyClientPin', {'pinHash': CryptoJS.SHA512(pin).toString()})
                    .then(response => {
                        if (response.data.error) {
                            this.$store.dispatch('alert/error', response.data.status);
                            localStorage.removeItem('securityPin');
                            localStorage.removeItem('csrf');
                            localStorage.removeItem('2FAVerification');
                            localStorage.removeItem('authTokenAcquired');
                            this.$store.dispatch('account/logout').then(response => window.location.reload(true));
                        } else {
                            this.loading = false;
                        }
                    });
            },
            validateUser() {
                this.userValidated = false;
                if (Object.keys(this.$store.getters['account/account']).length === 0) {
                    let userStore = this.$store.getters['account/userStore'];
                    return this.$store.dispatch('account/get').then(response => {
                        userStore.getLoggedUser().setAccountData(response);
                        let securityPin = userStore.getLoggedUser().getSecurityPin();
                        // User is logged and is on login page -> redirect him to dashboard
                        if (this.$route.name === 'login' || (securityPin === null && this.$route.name !== 'accountRecoverPin')) {
                            this.$router.push({name: 'accountCheckPin'});
                        }
                        this.userValidated = true;
                        return true;
                    }).catch(error => {
                        // there is a possiblity that user is logged, but the csrf token expired in the meantime
                        if(userStore.somebodyIsLoggedIn()) {
                            userStore.getLoggedUser().logOut();
                        }
                        // If user is not logged and is he on private page redirect him to login!
                        if (this.$route.meta.public !== true) {
                            this.$router.push({name: 'login'});
                        }
                        this.userValidated = true;
                        return false;
                    });
                } else {
                    this.userValidated = true;
                }

            },
            getAppInfo() {
                this.$store.dispatch('service/appInfo').then(response => {

                    this.hasGeoIPAccess = response.data.allowedAccess
                    this.appVersion = {
                        'server':response.data.appVersion,
                        'client':this.getClientAppVersion()
                    };
                    if(!['dev','unknown'].includes(this.appVersion.client) && this.appVersion.client != this.appVersion.server) {
                    // if(!['unknown'].includes(this.appVersion.client) && this.appVersion.client != this.appVersion.server) {
                        //only reload once in 10 minutes
                        if(!localStorage.hasOwnProperty('vReload') || localStorage.getItem('vReload') < (Date.now() - (10*60*1000))) {
                            localStorage.setItem('vReload',Date.now());
                            location.reload(true);
                            // this.$store.dispatch('log/log',{
                            //     'name':'system.versionReloaded',
                            //     'context': 'serverVersion:'+this.appVersion.server+';clientVersion:'+this.appVersion.client
                            // }).then(() => {
                            //     localStorage.setItem('vReload',Date.now());
                            //     location.reload(true);
                            // });

                        }
                    }
                    this.appInfoLoading = false
                    this.resolvedCountry = response.data.country
                }).catch(() => {
                    this.appInfoLoading = false
                })
            },
            checkForTimeToLogout() {
                //TODO: userStore : use appStore variables, this should only happen when automatic logout is set
                const authTokenAcquired = localStorage.getItem('authTokenAcquired')
                if (null === authTokenAcquired) {
                    this.timeToLogout = 0
                    return;
                }

                try {
                    // modal should show (acquired + 30 minutes > now) or 10 minutes before auto logout
                    const timestamp = JSON.parse(authTokenAcquired);
                    this.timeToLogout = (timestamp + 40 * 60 * 1000) - Date.now();
                } catch (e) {
                    localStorage.removeItem('authTokenAcquired')
                    this.timeToLogout = 0
                }
                setTimeout(this.checkForTimeToLogout, 1000)
                this.isLoggedOut = null === localStorage.getItem('csrf')
                this.$nextTick(() => {
                    if (null !== localStorage.getItem('csrf') && this.timeToLogout <= 0) {
                        this.$store.dispatch('account/logout').then(() => {
                            this.$router.push({name: 'login'})
                        })
                    }
                })
            },
            refreshToken() {
                this.$store.dispatch('account/refreshToken').then(() => {
                    this.timeToLogout = 2 * 60 * 60 * 1000;
                })
            },
            getClientAppVersion() {
                let version = 'unknown';
                let scripts = document.getElementsByTagName('script');
                let lastScript = scripts[scripts.length-1];
                if(lastScript) {
                    let scriptName = lastScript.src;
                    if (scriptName.includes('app.') && scriptName.includes('.js')) {
                        version = scriptName.split('app.')[1].replace('.js','');
                    }
                    if(version === 'js') {
                        version = 'dev';
                    }
                }
                return version;
            },
        },
    }
</script>
<style lang="sass">
  @import '../assets/styles/template.scss'
  @import 'cookieconsent/build/cookieconsent.min.css'

</style>
<style lang="scss">
  #mainMenu {
    > .navbar {
      padding: 0 !important;
    }
  }

  .logo {
    max-width: 100%;
    max-height: 75px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/App.vue